import { parseDateWithFormat } from "../common/helpers/formatDate";

/**
 * Parse report date values for table sorting.
 * Slash-separated dates use organisation date_format; ISO timestamps parse as-is.
 */
export const parseReportDateForSort = (dateValue) => {
  if (dateValue === null || dateValue === undefined || dateValue === "") return null;

  if (typeof dateValue !== "string") {
    if (dateValue instanceof Date) {
      const timestamp = dateValue.getTime();
      return Number.isFinite(timestamp) ? timestamp : null;
    }
    dateValue = String(dateValue);
  }

  const trimmed = dateValue.trim();
  if (!trimmed) return null;

  if (trimmed.includes("T") || /^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
    const isoTimestamp = Date.parse(trimmed);
    return Number.isFinite(isoTimestamp) ? isoTimestamp : null;
  }

  return parseDateWithFormat(trimmed);
};
